import { css } from '@emotion/css';

const card = css`
  border-radius: var(--radius-2);
  border: 1px solid var(--colors-neutral-200);
  padding: var(--spacings-4) var(--spacings-3);
`;

const cardSeparator = css`
  > div {
    margin-bottom: var(--spacings-2);
  }
`;

const instructionsTitle = css`
  margin-bottom: var(--spacings-4) !important;
`;

const instructionsField = css`
  display: inline-block;
  width: 100%;
  color: var(--colors-neutral-500);
  max-width: 50%;
  padding-right: var(--spacings-2);
  text-overflow: ellipsis;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 50%;
    text-align: left;
  }
`;

const instructionsValues = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: var(--colors-primary-900);
  font-weight: 500 !important;
  gap: var(--spacings-2);

  @media (min-width: 768px) {
    justify-content: space-between;
    width: 50%;
    text-align: left;
  }
`;

const swiftCodeWrapper = css`
  display: flex;
  align-items: center;
  gap: var(--spacings-2);

  button {
    padding: 0;
  }
`;

const internationalPayment = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: var(--spacings-2);
  justify-content: space-between;
`;

const swiftCodeText = css`
  color: var(--colors-neutral-500);
`;

const rows = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: flex-start;
`;

const fieldRow = css`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacings-2);
`;

const valueText = css`
  max-width: calc(100% - 32px);
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.5;
`;

const alert = css`
  margin-top: var(--spacings-2);
  background-color: var(--colors-neutral-150) !important;
  color: var(--colors-neutral-500) !important;

  p:first-of-type {
    margin-bottom: var(--spacings-1);
  }

  svg {
    color: var(--colors-neutral-500) !important;
  }
`;

const internationalPaymentAlert = css`
  margin: var(--spacings-2) 0;

  &&& .MuiAlert-root {
    background: var(--colors-primary-100);
  }

  & .MuiAlert-message {
    color: var(--colors-primary-500);
  }

  &&& .MuiAlert-icon {
    color: var(--colors-primary-500);
  }
`;

const InstructionsStyles = {
  card,
  cardSeparator,
  instructionsTitle,
  instructionsField,
  instructionsValues,
  swiftCodeWrapper,
  internationalPayment,
  swiftCodeText,
  rows,
  fieldRow,
  valueText,
  alert,
  internationalPaymentAlert,
};

export default InstructionsStyles;
